// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.risk-level-chart-container[data-v-2694b4f9] {\n  overflow: hidden;\n}\n.risk-level-chart[data-v-2694b4f9] {\n  position: relative;\n  top: -25px;\n  left: -90px;\n  width: 1140px;\n  height: 425px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"risk-level-chart-container": "risk-level-chart-container",
	"risk-level-chart": "risk-level-chart"
};
module.exports = ___CSS_LOADER_EXPORT___;
